import React, { useState } from 'react';
import { Header } from './components/Header';
import { Dashboard } from './components/Dashboard';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  return <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-blue-50" data-id="element-0">
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-1" />
      <main className="container mx-auto px-4 py-6" data-id="element-2">
        <Dashboard timeRange={timeRange} data-id="element-3" />
      </main>
    </div>;
};